import React, { useState } from 'react';
import { connect } from 'react-redux';
import ReportDrawer from 'containers/Reports/drawer';
import { resetState } from 'actions/reports';
import {
  ResultsRow,
  PlainButton,
  ResultsData,
  NoWrapTD,
} from 'components/styled-components';
import styled from 'styled-components';

const RowBase = ({
  name,
  description,
  drawer,
  resetState,
  resetDrawerState = () => null,
  ...rest
}) => {
  const [isOpen, toggleOpen] = useState(false);

  const handleClose = () => {
    toggleOpen(false);
    resetState();
    resetDrawerState();
  };
  return (
    <ResultsRow>
      <NoWrapHeader>{name}</NoWrapHeader>
      <TableDataWithHeaders>{description}</TableDataWithHeaders>
      <TableDataWithHeaders>
        <FloatButton onClick={toggleOpen}>CREATE REPORT</FloatButton>
      </TableDataWithHeaders>

      <ReportDrawer
        isOpen={isOpen}
        handleClose={handleClose}
        title={name}
        {...rest}
      >
        {drawer}
      </ReportDrawer>
    </ResultsRow>
  );
};

const FloatButton = styled(PlainButton)`
  float: right;
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    float: none;
    margin-left: 0;
  }
`;

const NoWrapHeader = styled(NoWrapTD)`
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    display: block;
    /* behave like a row*/
    border: none;
    border-bottom: 1px solid #c9c9c9;
    position: relative;
    padding-left: 50%;

    &::before {
      /* Now like a table header */
      position: absolute;
      /* Top/left values mimic padding */
      top: 1rem;
      left: 1rem;
      width: 45%;
      padding-right: 10px;
      white-space: nowrap;
    }
    /*
Label the data
*/
    &:nth-of-type(1):before {
      content: 'Report Name';
    }
  }
`;

const TableDataWithHeaders = styled(ResultsData)`
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    /*
	Label the data
	*/
    &:nth-of-type(2):before {
      content: 'Description';
    }
  }
`;

const Row = connect(
  null,
  { resetState }
)(RowBase);

export default Row;
